import {Locale} from '../../../../RootProvider/LocaleContext';
import getNumberSeparatorsFromLocale from '../../../../localeUtils/getNumberSeparatorsFromLocale';

const getNumberFromLocaleString = (inputValue: string, locale: Locale): number => {
  const {decimalSeparator, thousandsSeparator} = getNumberSeparatorsFromLocale(locale);

  const thousandsParts = inputValue.split(thousandsSeparator);
  const [numberBeforeDecimal, numberAfterDecimal] = thousandsParts[thousandsParts.length - 1].split(decimalSeparator);

  // remove the numbers after the decimal for the last number
  thousandsParts[thousandsParts.length - 1] = numberBeforeDecimal;

  const formattedString = [thousandsParts.join(''), numberAfterDecimal].join('.'); // parseFloat understands decimal as .
  const formattedValue = parseFloat(formattedString);

  return formattedValue;
};
export default getNumberFromLocaleString;
